import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import Missions from '../views/Missions.vue'
import Users from '../views/Users.vue'
import EditMission from '../views/EditMission.vue'
import EditUser from '../views/EditUser.vue'
import Register from '../views/Register.vue'
import MissionRunner from '../views/MissionRunner.vue'
import Earworms from '../views/Earworms.vue'
import EarwormBuilder from '../views/EarwormBuilder.vue'
import EarwormPlayer from '../views/EarwormPlayer.vue'
import Voices from '../views/Voices.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/login',
      name: 'login-page',
      component: Login
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/missions',
      name: 'missions',
      component: Missions
    },
    {
      path: '/users',
      name: 'users',
      component: Users
    },
    {
      path: '/family',
      name: 'family',
      component: () => import('../views/Family.vue')
    },
    {
      path: '/missions/:id/edit',
      name: 'edit-mission',
      component: EditMission
    },
    {
      path: '/edit-user/:id?',
      name: 'edit-user',
      component: EditUser
    },
    {
      path: '/child-dashboard/:id',
      name: 'child-dashboard',
      component: () => import('../views/ChildDashboard.vue')
    },
    {
      path: '/mission-runner/:id',
      name: 'mission-runner',
      component: MissionRunner
    },
    {
      path: '/mission-history/:id',
      name: 'mission-history',
      component: () => import('../views/MissionHistory.vue')
    },
    {
      path: '/earworms',
      name: 'earworms',
      component: Earworms
    },
    {
      path: '/earworm-builder/:id?',
      name: 'earworm-builder',
      component: EarwormBuilder
    },
    {
      path: '/earworm-player/:id',
      name: 'earworm-player',
      component: EarwormPlayer
    },
    {
      path: '/voices',
      name: 'voices',
      component: Voices
    }
  ]
})

export default router
